import React, { useMemo } from "react";
import PropTypes from "prop-types";

import { Icon, EnhancedTooltip } from "rhombus-react";

import { noop } from "utils/common";
import { API_URL } from "utils/constants";

export default function ImageThumbnail(props){
	const {
		name,
		libraryId,
		onClear = noop,
	} = props;

	const src = useMemo(() => {
		if(libraryId && name){
			return `${API_URL}/crm/v1/creative-libraries/${libraryId}/images/show/${name}`;
		}
		return "";
	}, [libraryId, name]);

	return (
		<>
			<div data-tip data-for={`${name}-tooltip`} className="image-thumbnail">
				<img src={src} alt={name} />
				<Icon className="clear-button" name="clear" onClick={onClear} />
			</div>
			<EnhancedTooltip id={`${name}-tooltip`} content={`${name}`} />
		</>
	);
}

ImageThumbnail.displayName = "ImageThumbnail";

ImageThumbnail.propTypes = {
	name: PropTypes.string,
	libraryId: PropTypes.oneOfType([
		PropTypes.string,
		PropTypes.number
	]),
	onClear: PropTypes.func,
};

ImageThumbnail.defaultProps = {
	onClear: noop,
};
